module.exports = __webpack_public_path__ + "static/media/to_top.8187a9b4.svg";